import * as React from 'react';
import { LoggedIn } from '../../LoggedIn/LoggedIn';
import { Header as PackagePickerHeader } from '@wix/package-picker-components';
import WixStudioLogo from '../WixStudioAssets/wix-studio-logo.svg';
import s from './Header.scss';
import { RootStore, withInjectedRootStore } from '../../../providers';
import { Box } from '@wix/design-system';
import { SwitchPlanNotificationBar } from 'components/SwitchPlanNotificationBar/SwitchPlanNotificationBar';
import classNames from 'classnames';
import { PackagePickerType } from 'enums';

interface HeaderProps {
  rootStore: RootStore;
}

export const HeaderComp: React.FC<HeaderProps> = ({ rootStore }) => {
  const {
    appContext: { currentPlanDetails, packagePickerType },
    isSwitchPlan,
  } = rootStore.appStore;

  const isEditorXToStudioPackagePicker =
    packagePickerType === PackagePickerType.EditorXToStudio;
  const shouldRenderSwitchPlanNotification = currentPlanDetails && isSwitchPlan;

  return (
    <LoggedIn>
      {(isLoggedIn) =>
        isLoggedIn && (
          <Box direction='vertical'>
            <PackagePickerHeader
              background='none'
              className={classNames(s.header, {
                [s.hasSwitchPlanNotification]:
                  shouldRenderSwitchPlanNotification &&
                  !isEditorXToStudioPackagePicker,
                [s.withBoxShadow]: shouldRenderSwitchPlanNotification,
              })}
              logo={<WixStudioLogo />}
            >
              {shouldRenderSwitchPlanNotification &&
                !isEditorXToStudioPackagePicker && (
                  <Box width='100%' align='center' flexGrow={1}>
                    <SwitchPlanNotificationBar />
                  </Box>
                )}
            </PackagePickerHeader>
          </Box>
        )
      }
    </LoggedIn>
  );
};

export const Header = withInjectedRootStore(HeaderComp);
